import "@/styles/base.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "@/app/providers";
import { applyLegacyRedirects } from "@/app/redirects";

// Old hash routes and `/?run=` are rewritten before the router reads the URL.
applyLegacyRedirects();

const root = document.getElementById("root");
if (!root) throw new Error("#root is missing from index.html");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
